import React from 'react';
import AppPart from '../../Shared/AppPart/AppPart';
import image from '../../../Assets/Cards/wireframeConcept.webp';
import image2 from '../../../Assets/Cards/wireframeDashboard.webp';

function Concept(){
    return(
        <>
        <AppPart 
        title="Take ideas from concept to creation"
        desc="With our easy-to-use wireframe tool, your team can design user interfaces for webpages and mobile apps. Simplify your design process and move seamlessly from low-fidelity to high-fidelity."
        styles="reversed-app-frame"
        image={image}
        />
          <AppPart 
        title="Drag and drop wireframe templates"
        desc="We’ve designed hundreds of simple wireframe assets for every device, all stored in our intuitive wireframing tool.
        All the assets are included with HostDesign, no add-ons necessary. We've taken care of everything, so you can focus on generating ideas."
        styles="bg-app-frame"
        image={image2}
        />
        </>
    )
};
export default Concept;